// Official NYC DOE 2026-2027 School Year Calendar
// Source: https://www.schools.nyc.gov/calendar/2026-2027-school-year-calendar
// September entries follow the school's own published September 2026 calendar.

const events = [
  // September 2026
  {
    id: 1,
    title: 'First Day of School',
    titleES: 'Primer Día de Clases',
    description: 'First day of school for all students.',
    descriptionES: 'Primer día de clases para todos los estudiantes.',
    date: new Date(2026, 8, 10),
    allDay: true,
    category: 'academic'
  },
  {
    id: 2,
    title: 'PTA Meeting — 9:00am',
    titleES: 'Reunión del PTA — 9:00am',
    description: 'PTA Meeting at 9:00am. All families are welcome.',
    descriptionES: 'Reunión del PTA a las 9:00am. Todas las familias son bienvenidas.',
    date: new Date(2026, 8, 15),
    allDay: false,
    time: '9:00 AM',
    category: 'pta'
  },
  {
    id: 3,
    title: 'Schools Closed — Yom Kippur',
    titleES: 'Escuelas Cerradas — Yom Kipur',
    description: 'Schools closed in observance of Yom Kippur.',
    descriptionES: 'Escuelas cerradas en observancia de Yom Kipur.',
    date: new Date(2026, 8, 21),
    allDay: true,
    category: 'holiday'
  },
  {
    id: 4,
    title: 'Parent-Teacher Conference & Back2School Night (Virtual)',
    titleES: 'Conferencia de Padres y Maestros y Noche de Regreso a Clases (Virtual)',
    description: 'Parent-Teacher Conference and Back2School Night, held virtually.',
    descriptionES: 'Conferencia de padres y maestros y Noche de Regreso a Clases, de forma virtual.',
    date: new Date(2026, 8, 30),
    allDay: true,
    category: 'pta'
  },

  // October 2026
  {
    id: 36,
    title: 'High School Application Opens',
    titleES: 'Se Abre la Solicitud para la Escuela Secundaria',
    description: 'The NYC high school application opens today for 8th grade students.',
    descriptionES: 'Hoy se abre la solicitud de escuela secundaria de NYC para los estudiantes de 8vo grado.',
    date: new Date(2026, 9, 6),
    allDay: true,
    category: 'academic'
  },
  {
    id: 5,
    title: 'Italian Heritage/Indigenous Peoples\' Day',
    titleES: 'Día de la Herencia Italiana/Pueblos Indígenas',
    description: 'Schools closed in observance of Italian Heritage/Indigenous Peoples\' Day.',
    descriptionES: 'Escuelas cerradas en observancia del Día de la Herencia Italiana/Pueblos Indígenas.',
    date: new Date(2026, 9, 12),
    allDay: true,
    category: 'holiday'
  },
  {
    id: 37,
    title: 'Community Celebration (Hispanic Heritage Month)',
    titleES: 'Celebración Comunitaria (Mes de la Herencia Hispana)',
    description: 'Community Celebration in honor of Hispanic Heritage Month.',
    descriptionES: 'Celebración comunitaria en honor al Mes de la Herencia Hispana.',
    date: new Date(2026, 9, 22),
    allDay: true,
    category: 'academic'
  },
  {
    id: 38,
    title: 'Halloween Extravaganza',
    titleES: 'Extravagancia de Halloween',
    description: 'Halloween Extravaganza from 3:45pm to 6:30pm.',
    descriptionES: 'Extravagancia de Halloween de 3:45pm a 6:30pm.',
    date: new Date(2026, 9, 29),
    allDay: false,
    time: '3:45 PM – 6:30 PM',
    category: 'pta'
  },
  {
    id: 39,
    title: 'Trunk or Treat & Family Movie Night',
    titleES: 'Trunk or Treat y Noche de Película Familiar',
    description: 'Trunk or Treat followed by Family Movie Night.',
    descriptionES: 'Trunk or Treat seguido de la Noche de Película Familiar.',
    date: new Date(2026, 9, 30),
    allDay: true,
    category: 'pta'
  },

  // November 2026
  {
    id: 6,
    title: 'Election Day — School Is Remote',
    titleES: 'Día de Elecciones — La Escuela Es Remota',
    description: 'School will be in session remotely for all students on Election Day.',
    descriptionES: 'Las clases se llevarán a cabo de forma remota para todos los estudiantes en el Día de Elecciones.',
    date: new Date(2026, 10, 3),
    allDay: true,
    category: 'academic'
  },
  {
    id: 7,
    title: 'Parent-Teacher Conference — Early Dismissal (11:45am)',
    titleES: 'Conferencia de Padres y Maestros — Salida Temprana (11:45am)',
    description: 'Parent-teacher conferences. Students are dismissed early at 11:45am.',
    descriptionES: 'Conferencias de padres y maestros. Los estudiantes salen temprano a las 11:45am.',
    date: new Date(2026, 10, 5),
    allDay: false,
    time: 'Dismissal at 11:45 AM',
    category: 'earlyDismissal'
  },
  {
    id: 40,
    title: 'Healthy Smiles Dental Visits — Grades 3K–2',
    titleES: 'Visitas Dentales Sonrisas Saludables — Grados 3K–2',
    description: 'Healthy Smiles dental visits for students in grades 3K–2.',
    descriptionES: 'Visitas dentales de Sonrisas Saludables para los estudiantes de los grados 3K–2.',
    date: new Date(2026, 10, 9),
    allDay: true,
    category: 'academic'
  },
  {
    id: 41,
    title: 'Healthy Smiles Dental Visits — Grades 3–5',
    titleES: 'Visitas Dentales Sonrisas Saludables — Grados 3–5',
    description: 'Healthy Smiles dental visits for students in grades 3–5.',
    descriptionES: 'Visitas dentales de Sonrisas Saludables para los estudiantes de los grados 3–5.',
    date: new Date(2026, 10, 10),
    allDay: true,
    category: 'academic'
  },
  {
    id: 8,
    title: 'Schools Closed — Veterans Day',
    titleES: 'Escuelas Cerradas — Día de los Veteranos',
    description: 'Schools closed in observance of Veterans Day.',
    descriptionES: 'Escuelas cerradas en observancia del Día de los Veteranos.',
    date: new Date(2026, 10, 11),
    allDay: true,
    category: 'holiday'
  },
  {
    id: 42,
    title: 'Spelling Bee — Grades K–4',
    titleES: 'Concurso de Ortografía — Grados K–4',
    description: 'Spelling Bee for students in grades K–4.',
    descriptionES: 'Concurso de ortografía para los estudiantes de los grados K–4.',
    date: new Date(2026, 10, 13),
    allDay: true,
    category: 'academic'
  },
  {
    id: 43,
    title: 'Healthy Smiles Dental Visits — Grades 6–8',
    titleES: 'Visitas Dentales Sonrisas Saludables — Grados 6–8',
    description: 'Healthy Smiles dental visits for students in grades 6–8.',
    descriptionES: 'Visitas dentales de Sonrisas Saludables para los estudiantes de los grados 6–8.',
    date: new Date(2026, 10, 19),
    allDay: true,
    category: 'academic'
  },
  {
    id: 44,
    title: 'Spelling Bee — Grades 5–8',
    titleES: 'Concurso de Ortografía — Grados 5–8',
    description: 'Spelling Bee for students in grades 5–8.',
    descriptionES: 'Concurso de ortografía para los estudiantes de los grados 5–8.',
    date: new Date(2026, 10, 20),
    allDay: true,
    category: 'academic'
  },
  {
    id: 45,
    title: 'Thanksgiving Potluck',
    titleES: 'Comida Compartida de Acción de Gracias',
    description: 'Thanksgiving Potluck celebration.',
    descriptionES: 'Celebración de comida compartida de Acción de Gracias.',
    date: new Date(2026, 10, 24),
    allDay: true,
    category: 'pta'
  },
  {
    id: 46,
    title: 'In Class Celebrations',
    titleES: 'Celebraciones en el Salón',
    description: 'Thanksgiving celebrations in each classroom.',
    descriptionES: 'Celebraciones de Acción de Gracias en cada salón.',
    date: new Date(2026, 10, 25),
    allDay: true,
    category: 'academic'
  },
  {
    id: 12,
    title: 'Thanksgiving Recess',
    titleES: 'Receso de Acción de Gracias',
    description: 'Schools closed for Thanksgiving Recess.',
    descriptionES: 'Escuelas cerradas por el Receso de Acción de Gracias.',
    date: new Date(2026, 10, 26),
    endDate: new Date(2026, 10, 27),
    allDay: true,
    category: 'holiday'
  },

  // December 2026 - January 2027
  {
    id: 13,
    title: 'Winter Recess',
    titleES: 'Receso de Invierno',
    description: 'Schools closed for Winter Recess.',
    descriptionES: 'Escuelas cerradas por el Receso de Invierno.',
    date: new Date(2026, 11, 24),
    endDate: new Date(2027, 0, 1),
    allDay: true,
    category: 'holiday'
  },

  // January 2027
  {
    id: 14,
    title: 'Rev. Dr. Martin Luther King Jr. Day',
    titleES: 'Día del Rev. Dr. Martin Luther King Jr.',
    description: 'Schools closed in observance of Rev. Dr. Martin Luther King Jr. Day.',
    descriptionES: 'Escuelas cerradas en observancia del Día del Rev. Dr. Martin Luther King Jr.',
    date: new Date(2027, 0, 18),
    allDay: true,
    category: 'holiday'
  },
  {
    id: 15,
    title: 'Regents Administration',
    titleES: 'Administración de Exámenes Regents',
    description: 'Regents Examination administration period.',
    descriptionES: 'Período de administración de Exámenes Regents.',
    date: new Date(2027, 0, 26),
    endDate: new Date(2027, 0, 29),
    allDay: true,
    category: 'testing'
  },

  // February 2027
  {
    id: 16,
    title: 'Professional Development Day — High Schools and 6-12 Schools',
    titleES: 'Día de Desarrollo Profesional — Escuelas Secundarias y Escuelas 6-12',
    description: 'Professional development day. Students who attend high schools and schools that serve only grades 6-12 are not in attendance. All other students attend school.',
    descriptionES: 'Día de desarrollo profesional. Los estudiantes de escuelas secundarias y de escuelas que sirven solo los grados 6-12 no asisten. Todos los demás estudiantes asisten a clases.',
    date: new Date(2027, 1, 1),
    allDay: true,
    category: 'academic'
  },
  {
    id: 17,
    title: 'Spring Semester Begins',
    titleES: 'Comienza el Semestre de Primavera',
    description: 'Spring semester begins.',
    descriptionES: 'Comienza el semestre de primavera.',
    date: new Date(2027, 1, 2),
    allDay: true,
    category: 'academic'
  },
  {
    id: 18,
    title: 'Midwinter Recess',
    titleES: 'Receso de Medio Invierno',
    description: 'Schools closed for Midwinter Recess.',
    descriptionES: 'Escuelas cerradas por el Receso de Medio Invierno.',
    date: new Date(2027, 1, 15),
    endDate: new Date(2027, 1, 19),
    allDay: true,
    category: 'holiday'
  },

  // March 2027
  {
    id: 19,
    title: 'Parent-Teacher Conferences for Elementary Schools and Pre-K Centers — Early Dismissal',
    titleES: 'Conferencias de Padres y Maestros para Escuelas Primarias y Centros Pre-K — Salida Temprana',
    description: 'Afternoon and evening parent-teacher conferences for elementary schools and Pre-K Centers. Students in these schools dismissed three hours early.',
    descriptionES: 'Conferencias de padres y maestros por la tarde y noche para escuelas primarias y centros Pre-K. Los estudiantes de estas escuelas salen tres horas antes.',
    date: new Date(2027, 2, 3),
    allDay: false,
    category: 'earlyDismissal'
  },
  {
    id: 20,
    title: 'Parent-Teacher Conferences for Middle Schools and D75 — Early Dismissal',
    titleES: 'Conferencias de Padres y Maestros para Escuelas Intermedias y D75 — Salida Temprana',
    description: 'Afternoon and evening parent-teacher conferences for middle schools and D75 schools. Students in these schools dismissed three hours early.',
    descriptionES: 'Conferencias de padres y maestros por la tarde y noche para escuelas intermedias y D75. Los estudiantes de estas escuelas salen tres horas antes.',
    date: new Date(2027, 2, 4),
    allDay: false,
    category: 'earlyDismissal'
  },
  {
    id: 21,
    title: 'Eid al-Fitr',
    titleES: 'Eid al-Fitr',
    description: 'Schools closed in observance of Eid al-Fitr.',
    descriptionES: 'Escuelas cerradas en observancia de Eid al-Fitr.',
    date: new Date(2027, 2, 9),
    allDay: true,
    category: 'holiday'
  },
  {
    id: 22,
    title: 'Evening Parent-Teacher Conferences for High Schools, K-12, and 6-12 Schools',
    titleES: 'Conferencias Vespertinas de Padres y Maestros para Escuelas Secundarias, K-12 y 6-12',
    description: 'Evening parent-teacher conferences for high schools, K-12 and 6-12 schools.',
    descriptionES: 'Conferencias vespertinas de padres y maestros para escuelas secundarias, K-12 y 6-12.',
    date: new Date(2027, 2, 18),
    allDay: false,
    category: 'pta'
  },
  {
    id: 23,
    title: 'Parent-Teacher Conferences for High Schools, K-12, and 6-12 — Early Dismissal',
    titleES: 'Conferencias de Padres y Maestros para Escuelas Secundarias, K-12 y 6-12 — Salida Temprana',
    description: 'Afternoon parent-teacher conferences for high schools, K-12 and 6-12 schools. Students in these schools dismissed three hours early.',
    descriptionES: 'Conferencias de padres y maestros por la tarde para escuelas secundarias, K-12 y 6-12. Los estudiantes de estas escuelas salen tres horas antes.',
    date: new Date(2027, 2, 19),
    allDay: false,
    category: 'earlyDismissal'
  },
  {
    id: 24,
    title: 'Good Friday',
    titleES: 'Viernes Santo',
    description: 'Schools closed in observance of Good Friday.',
    descriptionES: 'Escuelas cerradas en observancia del Viernes Santo.',
    date: new Date(2027, 2, 26),
    allDay: true,
    category: 'holiday'
  },

  // April 2027
  {
    id: 25,
    title: 'Spring Recess',
    titleES: 'Receso de Primavera',
    description: 'Schools closed for Spring Recess.',
    descriptionES: 'Escuelas cerradas por el Receso de Primavera.',
    date: new Date(2027, 3, 22),
    endDate: new Date(2027, 3, 30),
    allDay: true,
    category: 'holiday'
  },

  // May 2027
  {
    id: 26,
    title: 'Evening Parent-Teacher Conferences for High Schools, K-12, and 6-12 Schools',
    titleES: 'Conferencias Vespertinas de Padres y Maestros para Escuelas Secundarias, K-12 y 6-12',
    description: 'Evening parent-teacher conferences for high schools, K-12, and 6-12 schools.',
    descriptionES: 'Conferencias vespertinas de padres y maestros para escuelas secundarias, K-12 y 6-12.',
    date: new Date(2027, 4, 12),
    allDay: false,
    category: 'pta'
  },
  {
    id: 27,
    title: 'Evening Parent-Teacher Conferences for Middle Schools and D75 Schools',
    titleES: 'Conferencias Vespertinas de Padres y Maestros para Escuelas Intermedias y Escuelas D75',
    description: 'Evening parent-teacher conferences for middle schools and D75 schools.',
    descriptionES: 'Conferencias vespertinas de padres y maestros para escuelas intermedias y escuelas D75.',
    date: new Date(2027, 4, 13),
    allDay: false,
    category: 'pta'
  },
  {
    id: 28,
    title: 'Eid al-Adha',
    titleES: 'Eid al-Adha',
    description: 'Schools closed in observance of Eid al-Adha.',
    descriptionES: 'Escuelas cerradas en observancia de Eid al-Adha.',
    date: new Date(2027, 4, 17),
    allDay: true,
    category: 'holiday'
  },
  {
    id: 29,
    title: 'Evening Parent-Teacher Conferences for Elementary Schools and Pre-K Centers',
    titleES: 'Conferencias Vespertinas de Padres y Maestros para Escuelas Primarias y Centros Pre-K',
    description: 'Evening parent-teacher conferences for elementary schools and Pre-K Centers.',
    descriptionES: 'Conferencias vespertinas de padres y maestros para escuelas primarias y centros Pre-K.',
    date: new Date(2027, 4, 26),
    allDay: false,
    category: 'pta'
  },
  {
    id: 30,
    title: 'Memorial Day',
    titleES: 'Día de los Caídos',
    description: 'Schools closed in observance of Memorial Day.',
    descriptionES: 'Escuelas cerradas en observancia del Día de los Caídos.',
    date: new Date(2027, 4, 31),
    allDay: true,
    category: 'holiday'
  },

  // June 2027
  {
    id: 31,
    title: 'Clerical Day — Students Do Not Attend',
    titleES: 'Día Administrativo — Los Estudiantes No Asisten',
    description: 'Clerical Day. No classes for students attending 3-K, Pre-K, elementary schools, middle schools, K-12 schools, and standalone D75 programs.',
    descriptionES: 'Día Administrativo. No hay clases para los estudiantes de 3-K, Pre-K, escuelas primarias, escuelas intermedias, escuelas K-12 y programas D75 independientes.',
    date: new Date(2027, 5, 8),
    allDay: true,
    category: 'academic'
  },
  {
    id: 32,
    title: 'Anniversary Day/Chancellor\'s Conference Day — Students Do Not Attend',
    titleES: 'Día de Aniversario/Día de Conferencia del Canciller — Los Estudiantes No Asisten',
    description: 'Anniversary Day/Chancellor\'s Conference Day for staff development. Students do not attend school.',
    descriptionES: 'Día de Aniversario/Día de Conferencia del Canciller para el desarrollo del personal. Los estudiantes no asisten a la escuela.',
    date: new Date(2027, 5, 10),
    allDay: true,
    category: 'academic'
  },
  {
    id: 33,
    title: 'Regents Administration',
    titleES: 'Administración de Exámenes Regents',
    description: 'Regents Examination administration period.',
    descriptionES: 'Período de administración de Exámenes Regents.',
    date: new Date(2027, 5, 15),
    endDate: new Date(2027, 5, 18),
    allDay: true,
    category: 'testing'
  },
  {
    id: 34,
    title: 'Regents Administration',
    titleES: 'Administración de Exámenes Regents',
    description: 'Regents Examination administration period.',
    descriptionES: 'Período de administración de Exámenes Regents.',
    date: new Date(2027, 5, 21),
    endDate: new Date(2027, 5, 25),
    allDay: true,
    category: 'testing'
  },
  {
    id: 35,
    title: 'Last Day of School',
    titleES: 'Último Día de Clases',
    description: 'Last day of school for students in the 2026-2027 school year.',
    descriptionES: 'Último día de clases para los estudiantes del año escolar 2026-2027.',
    date: new Date(2027, 5, 28),
    allDay: true,
    category: 'academic'
  }
];

export default events;
